import React, {useState, useEffect} from 'react'

// Bootstrap Components
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Col, Row } from 'react-bootstrap';

// Custom Components
import Layout from '../components/layout/Layout'
import Container from 'react-bootstrap/esm/Container';

// Context
import { PortfolioContext } from '../context/PortfolioContext'
import { useParams, Link } from 'react-router';

// React Helmet
import { Helmet } from 'react-helmet';

export default function Portfolio() {
    const { name, id } = useParams();
    const { portfolioList } = PortfolioContext();
    const [portfolio, setPortfolio] = useState(null);

    useEffect(() => {
        if (portfolioList && id) {
        const portfolioDoc = portfolioList.find(
            (portfolio) => portfolio.portfolio_id === id
        );
        setPortfolio(portfolioDoc);
        }
    }, [portfolioList, id]);

    if (!portfolioList || !portfolio) {
        return <h2 className="text-center mt-5">Loading...</h2>;
    }

    return (
        <>
        <Helmet>
  <title>{portfolio.portfolio_name} | Beginner-Friendly Portfolio Breakdown | Stocks With Nik</title>

  <meta 
    name="description" 
    content={`A simple breakdown of the ${portfolio.portfolio_name} portfolio, including ETFs, allocations, risk level, and why beginners may want to consider this approach.`} 
  />

  <meta 
    name="keywords" 
    content={`${portfolio.portfolio_name}, beginner portfolio breakdown, ETF allocation, how to build a portfolio, dividend investing strategy, long-term investing for beginners`} 
  />

  <meta name="viewport" content="width=device-width, initial-scale=1" />
</Helmet>

        <Layout content={
            <>
                <Container>
                    <div className='pb-5 pt-5' style={{textAlign: "center"}}>
                        <h1>{portfolio.portfolio_name}</h1>
                    </div>
                    <div style={{textAlign: "center"}}>
                        {portfolio.portfolio_cover_image ? 
                        <>
                        <img src={portfolio.portfolio_cover_image} style={{width: "100%", maxWidth: "50rem", height: "auto", maxHeight: "400px", borderRadius: "10px"}} />
                        </> 
                        : 
                        <></>
                        }
                    </div>
                    <div className='pb-5 pt-2' style={{textAlign: "center"}}>
                        <p>{portfolio.portfolio_description}</p>
                    </div>
                    <div>
                        <h3 className='pb-3'>Holdings:</h3>
                        <Row>
                        {portfolio.portfolio_holdings.map((i) => {
                            return(
                                <>
                                <Col xs={12} md={6} className='p-3'>
                                            <Card className='p-3' style={{maxWidth: '30rem'}}>
                                                <h5>{i.holding_name}</h5>
                                                <h6>Ticker: {i.holding_ticker}</h6>
                                                <h6>Type: {i.holding_type}</h6>
                                                <h6>Category: {i.holding_category}</h6>
                                                <h6>Allocation Percentate: {i.holding_allocation_amount}%</h6>
                                                <br />
                                                <div>
                                                    <p>{i.holding_description}</p>
                                                </div>
                                            </Card>
                                </Col>
                                </>
                            )
                        })}
                        </Row>
                    </div>
                    <div className='w-100 pt-5' style={{textAlign: "center"}}>
                        <Link to='/portfolios'>
                            <Button>View All Portfolios</Button>
                        </Link>
                    </div>
                </Container>
            </>
        } />
        </>
    )
}
